import React, { type ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { linkifyNbfc } from "./NbfcLink";

interface PolicyLayoutProps {
  title: string;
  subtitle?: string;
  badge?: string;
  children: ReactNode;
}

const PolicyLayout: React.FC<PolicyLayoutProps> = ({ title, subtitle, badge, children }) => {
  return (
    <div className="min-h-screen w-full bg-white text-[#0F172A] font-sans selection:bg-[#CC1A1A] selection:text-white overflow-x-hidden">

      <div className="relative z-10 flex w-full flex-col items-center">
        <Navbar />

        {/* Policy Hero Section */}
        <section className="w-full bg-white pt-28 pb-10 px-6 lg:px-24 flex items-center relative overflow-hidden">

          {/* Decorative Corner Accents */}
          <div className="absolute top-[-10%] left-[-5%] w-[40vw] h-[40vw] bg-[#CC1A1A] opacity-[0.03] rounded-full blur-[120px] pointer-events-none" />
          <div className="absolute bottom-[-10%] right-[-5%] w-[35vw] h-[35vw] bg-[#CC1A1A] opacity-[0.04] rounded-full blur-[120px] pointer-events-none" />

          <div className="max-w-[1200px] mx-auto text-center relative z-10">
            {badge && (
              <div className="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-[#CC1A1A]/10 text-[#CC1A1A] font-black text-xs uppercase tracking-[0.3em] mb-8">
                {badge}
              </div>
            )}

            <h1 className="text-4xl xl:text-5xl font-bold text-[#CC1A1A] tracking-tighter mb-4 leading-tight">
              
              {title}
            </h1>

            {subtitle && (
              <p className="text-gray-500 text-base font-light lg:text-lg">
                {linkifyNbfc(subtitle)}
              </p>
            )}
          </div>
        </section>

        {/* Content Section */}
        <div className="w-full bg-white py-24 relative z-10 border-t border-[#E5E7EB]">
          <div className="max-w-[1000px] mx-auto px-6 lg:px-12">
            <div className="prose prose-slate max-w-none
              prose-headings:text-[#0F172A] prose-headings:font-black prose-headings:tracking-tight
              prose-p:text-[#4B5563] prose-p:font-medium prose-p:leading-relaxed
              prose-strong:text-[#0F172A] prose-strong:font-black
              prose-ul:list-disc prose-li:text-[#4B5563]
              space-y-12">
              {children}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PolicyLayout;